import {
  type CloseSlideoverOptions,
  type SlideoverStoreProps,
  useSlideoverStore,
} from '../store/slideover.store';

export const useSlideover = () => {
  const slideoverStore = useSlideoverStore();

  return {
    props: slideoverStore.slideoverState.props,
    events: slideoverStore.slideoverState.events,
    config: slideoverStore.slideoverState.config,
    labels: slideoverStore.slideoverState.labels,
    openSlideover: (payload: SlideoverStoreProps) => {
      slideoverStore.openSlideover(payload);
    },
    closeSlideover: (options?: CloseSlideoverOptions) => {
      slideoverStore.closeSlideover(options);
    },
  };
};
